import type { InterventionReportQuery } from '@innovamat/glow-api-client';

export const catchUpFakeData: InterventionReportQuery = {
  interventionReport: {
    weeks: {
      currentWeekNumber: 18,
      interventionWeeks: [
        {
          startDate: '2025-01-13',
          endDate: '2025-01-19',
        },
        {
          startDate: '2025-01-20',
          endDate: '2025-01-26',
        },
        {
          startDate: '2025-01-27',
          endDate: '2025-02-02',
        },
        {
          startDate: '2025-02-03',
          endDate: '2025-02-09',
        },
        {
          startDate: '2025-02-10',
          endDate: '2025-02-16',
        },
        {
          startDate: '2025-02-17',
          endDate: '2025-02-23',
        },
        {
          startDate: '2025-02-24',
          endDate: '2025-03-02',
        },
        {
          startDate: '2025-03-03',
          endDate: '2025-03-09',
        },
        {
          startDate: '2025-03-10',
          endDate: '2025-03-16',
        },
        {
          startDate: '2025-03-17',
          endDate: '2025-03-23',
        },
        {
          startDate: '2025-03-24',
          endDate: '2025-03-30',
        },
        {
          startDate: '2025-03-31',
          endDate: '2025-04-06',
        },
        {
          startDate: '2025-04-07',
          endDate: '2025-04-13',
        },
        {
          startDate: '2025-04-14',
          endDate: '2025-04-20',
        },
        {
          startDate: '2025-04-21',
          endDate: '2025-04-27',
        },
        {
          startDate: '2025-04-28',
          endDate: '2025-05-04',
        },
      ],
    },
    studentsCurrentlyInIntervention: [
      {
        uuid: 'af972ceb-cbaa-49dd-b9a6-4a95784f446a',
        firstName: 'Emily',
        lastName: 'Ramirez',
        initialArithmeticFluency: 3.5,
        currentArithmeticFluency: 1.9999999999999998,
        weeks: [
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
        ],
        lastWeekInIntervention: null,
      },
      {
        uuid: 'abeb88d6-7ee2-4ca2-b5c5-7bf05aad0718',
        firstName: 'Daniel',
        lastName: 'Parker',
        initialArithmeticFluency: 0.5,
        currentArithmeticFluency: 3.5,
        weeks: [
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
        ],
        lastWeekInIntervention: null,
      },
      {
        uuid: '319210bf-dc1f-4af3-8710-9ad7962c15c6',
        firstName: 'Sophia',
        lastName: 'Morales',
        initialArithmeticFluency: 2.9999999999999996,
        currentArithmeticFluency: 8.5,
        weeks: [
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
        ],
        lastWeekInIntervention: null,
      },
      {
        uuid: '8700c2b9-fb32-4bd7-b1c7-95753ddbbd42',
        firstName: 'William',
        lastName: 'Reyes',
        initialArithmeticFluency: 2,
        currentArithmeticFluency: 2,
        weeks: [
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
        ],
        lastWeekInIntervention: null,
      },
      {
        uuid: 'cfe72e60-3a2e-4fd8-9d6d-9ed03cef41dd',
        firstName: 'Laura',
        lastName: 'Thompson',
        initialArithmeticFluency: 3.5,
        currentArithmeticFluency: 3,
        weeks: [
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
        ],
        lastWeekInIntervention: null,
      },
      {
        uuid: '0c81f580-7fa8-440b-a45e-cac6eea32aff',
        firstName: 'James',
        lastName: 'Herrera',
        initialArithmeticFluency: 2.5,
        currentArithmeticFluency: 3,
        weeks: [
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
        ],
        lastWeekInIntervention: null,
      },
      {
        uuid: 'ca948e8a-b6d5-4833-921e-0b4d75824c90',
        firstName: 'Isabella',
        lastName: 'Mitchell',
        initialArithmeticFluency: 2,
        currentArithmeticFluency: 4,
        weeks: [
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
        ],
        lastWeekInIntervention: null,
      },
      {
        uuid: '2521d8ae-6303-4f0f-ab51-85ba3ae3bd90',
        firstName: 'Tyler',
        lastName: 'Vega',
        initialArithmeticFluency: 4,
        currentArithmeticFluency: 2.5,
        weeks: [
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
        ],
        lastWeekInIntervention: null,
      },
      {
        uuid: '4db51c7d-eb88-4868-a963-1758d7110250',
        firstName: 'Olivia',
        lastName: 'Fletcher',
        initialArithmeticFluency: 5,
        currentArithmeticFluency: 5.5,
        weeks: [
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 4,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 3,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 1,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 2,
            availableInterventionSessions: 4,
          },
          {
            completedInterventionSessions: 0,
            availableInterventionSessions: 4,
          },
        ],
        lastWeekInIntervention: null,
      },
    ],
    studentsNoLongerInIntervention: [],
  },
};
